// src/routes.js
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import DuyetAccount from '@app/pages/appHuanLuyenDaoTao/common/duyetAccount/DuyetAccount';
import TraCuuCanBo from '@app/pages/appHuanLuyenDaoTao/common/traCuuCanBo/TraCuuCanBo';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import KySo from '@app/pages/kySo/KySo';
import SignedHuman from '@app/pages/signedHuman/SignedHuman';
import SignedHumanAdd from '@app/pages/signedHuman/SignedHumanAdd';
import SignedHumanEdit from '@app/pages/signedHuman/SignedHumanEdit';

// Common
import ChuDe from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDe';
import ChuDeAdd from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDeAdd';
import ChuDeEdit from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDeEdit';
import HoaDonThanhToan from '@app/pages/appHuanLuyenDaoTao/common/hoaDonThanhToan/HoaDonThanhToan';
import HoaDonThanhToanAdd from '@app/pages/appHuanLuyenDaoTao/common/hoaDonThanhToan/HoaDonThanhToanAdd';
import HoaDonThanhToanEdit from '@app/pages/appHuanLuyenDaoTao/common/hoaDonThanhToan/HoaDonThanhToanEdit';
import DanhMucPhanMem from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMem';
import DanhMucPhanMemAdd from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMemAdd';
import DanhMucPhanMemEdit from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMemEdit';
import ChuongTrinhHoc from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHoc';
import ChuongTrinhHocAdd from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHocAdd';
import ChuongTrinhHocEdit from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHocEdit';
import Nganh from '@app/pages/appHuanLuyenDaoTao/common/nganh/Nganh';
import NganhAdd from '@app/pages/appHuanLuyenDaoTao/common/nganh/NganhAdd';
import NganhEdit from '@app/pages/appHuanLuyenDaoTao/common/nganh/NganhEdit';
import ChuyenNganh from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganh';
import ChuyenNganhAdd from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganhAdd';
import ChuyenNganhEdit from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganhEdit';
import DanhMucVanBangChungChi from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChi';
import DanhMucVanBangChungChiAdd from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChiAdd';
import DanhMucVanBangChungChiEdit from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChiEdit';

// QuyTrinhTuyenSinh
//////
// NhomTieuChi
import NhomTieuChi from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/nhomTieuChi/NhomTieuChi';
import NhomTieuChiAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/nhomTieuChi/NhomTieuChiAdd';
import NhomTieuChiEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/nhomTieuChi/NhomTieuChiEdit';

// TieuChi
import TieuChi from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/tieuChi/TieuChi';
import TieuChiAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/tieuChi/TieuChiAdd';
import TieuChiEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/tieuChi/TieuChiEdit';

// MucDanhGia
import MucDanhGia from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/mucDanhGia/MucDanhGia';
import MucDanhGiaAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/mucDanhGia/MucDanhGiaAdd';
import MucDanhGiaEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhTienSi/mucDanhGia/MucDanhGiaEdit';

// QuanLyTuyenSinh
//////
import BieuMauTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/bieuMauTuyenSinh/BieuMauTuyenSinh';
import DotTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/dotTuyenSinh/DotTuyenSinh';
import DotTuyenSinhAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/dotTuyenSinh/DotTuyenSinhAdd';
import DotTuyenSinhEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/dotTuyenSinh/DotTuyenSinhEdit';

import LopDaoTaoLienTuc from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoLienTuc/LopDaoTaoLienTuc';
import LopDaoTaoLienTucAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoLienTuc/LopDaoTaoLienTucAdd';
import LopDaoTaoLienTucEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoLienTuc/LopDaoTaoLienTucEdit';

import LopDaoTaoThucHanh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoThucHanh/LopDaoTaoThucHanh';
import LopDaoTaoThucHanhAdd from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoThucHanh/LopDaoTaoThucHanhAdd';
import LopDaoTaoThucHanhEdit from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/lopDaoTaoThucHanh/LopDaoTaoThucHanhEdit';

import DangKyDotTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/dotTuyenSinh/DangKyDotTuyenSinh';
import HoSoTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/hoSoTuyenSinh/HoSoTuyenSinh';
import DuyetHoSoTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quanLyTuyenSinh/tuyenSinhChung/duyetHoSoTuyenSinh/DuyetHoSoTuyenSinh';

// QuanLyDaoTaoTienSi
import HoSoNghienCuuSinh from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/hoSoNghienCuuSinh/HoSoNghienCuuSinh';
import GiaiDoanDaoTaoNCS from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/hoSoNghienCuuSinh/GiaiDoanDaoTaoNCS';
import YeuCauThayDoi from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/hoSoNghienCuuSinh/YeuCauThayDoi';
import QuanLyHoSoNCS from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/quanLyHoSoNCS/QuanLyHoSoNCS';
import QuanLyGiaiDoanDaoTaoNCS from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/quanLyHoSoNCS/QuanLyGiaiDoanDaoTaoNCS';
import BieuMauTienSi from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/bieuMauTienSi/BieuMauTienSi';
import DanhMucHoSoTienSi from '@app/pages/appHuanLuyenDaoTao/quanLyDaoTaoTienSi/danhMucHoSoTienSi/DanhMucHoSoTienSi';
// CapNhatKienThucYKhoa (CME)
import CMEConfig from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeConfig/CMEConfig';
import CMEDictionary from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeDictionary/CMEDictionary';
import CMEDuyetHoSo from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/duyetHoSo/CMEDuyetHoSo';
import CMEEvent from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeEvent/CMEEvent';
import CMEDashboard from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEDashboard';
import CMEHoSo from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSo';
import CMEHoSoAdd from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSoAdd';
import CMEHoSoEdit from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSoEdit';
import CMEDieuDuongEvent from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeDieuDuong/CMEDieuDuongEvent';
import CMEDieuDuongDuyet from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeDieuDuong/CMEDieuDuongDuyet';
import DaoTaoThucHanh from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/DaoTaoThucHanh';
import NganhDaoTao from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/NganhDaoTao';
import ChuongTrinhDaoTao from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/ChuongTrinhDaoTao';
import KhoaDaoTao from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/KhoaDaoTao';
import HopDongDaoTao from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/HopDongDaoTao';
import KhoaDaoTaoDetail from '@app/pages/appHuanLuyenDaoTao/daoTaoThucHanh/KhoaDaoTaoDetail';

// TrienKhaiDaoTaoLienTuc
import LopDaoTaoLienTucTrienKhai from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTuc';
import LopDaoTaoLienTucTrienKhaiGV from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTucGV';
import LopDaoTaoLienTucTrienKhaiDetailGV from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTucDetailGV';
import LopDaoTaoLienTucTrienKhaiHV from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTucHV';
import LopDaoTaoLienTucTrienKhaiDetailHV from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTucDetailHV';
import LopDaoTaoLienTucTrienKhaiDetail from '@app/pages/appHuanLuyenDaoTao/trienKhaiDaoTaoLienTuc/LopDaoTaoLienTucDetail';

// TrienKhaiHuongDanThucHanh
import LopHuongDanThucHanhTrienKhai from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanh';
import LopHuongDanThucHanhTrienKhaiGV from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanhGV';
import LopHuongDanThucHanhTrienKhaiDetailGV from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanhDetailGV';
import LopHuongDanThucHanhTrienKhaiHV from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanhHV';
import LopHuongDanThucHanhTrienKhaiDetailHV from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanhDetailHV';
import LopHuongDanThucHanhTrienKhaiDetail from '@app/pages/appHuanLuyenDaoTao/trienKhaiHuongDanThucHanh/LopHuongDanThucHanhDetail';

// QuanLyGPHN_CCHN
import PhamViHanhNghe from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNghe';
import PhamViHanhNgheAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNgheAdd';
import PhamViHanhNgheEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNgheEdit';

import GiayPhepHanhNghe from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNghe';
import GiayPhepHanhNgheAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNgheAdd';
import GiayPhepHanhNgheEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNgheEdit';
import DanhSachDuyetHoSo from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/DanhSachDuyetHoSoMenu';

import VanBang from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/vanBang/VanBang';
import VanBangAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/vanBang/VanBangAdd';
import VanBangEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/vanBang/VanBangEdit';

import ChungChiNgoaiNgu from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/chungChiNgoaiNgu/ChungChiNgoaiNgu';
import ChungChiNgoaiNguAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/chungChiNgoaiNgu/ChungChiNgoaiNguAdd';
import ChungChiNgoaiNguEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/chungChiNgoaiNgu/ChungChiNgoaiNguEdit';
import DanhSachDuyetNgoaiNgu from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/thongKeDuyet/DanhSachDuyetNgoaiNgu';
import DanhMucPhanMemShow from '@app/pages/appHuanLuyenDaoTao/danhMucPhanMemShow/DanhMucPhanMemShow';

const rawRoutes = [
  // dashboard
  {
    path: "/", // bạn có thể thêm HOME_PATH = '/'
    exact: true,
    component: Dashboard,
    isPublic: false,
    // label:      'Dashboard',
    controller: '',
    action: '',
    label: "Dashboard",
    menu: true,
    isPublic: false,
  },
  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    isPublic: false,
    // controller: 'Profile',
    // action:     'View',
    // label:      'Profile',
    controller: '',
    action: '',
    label: "Thông tin cá nhân",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_SHOW_PATH,
    exact: true,
    component: DanhMucPhanMemShow,
    isPublic: false,
    controller: '',
    action: '',
    label: 'Trang chủ',
    menu: false,
    isPublic: false,
  },
  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    isPublic: false,
    controller: 'Account',
    // controller: '',
    action: '',
    label: "Tài khoản",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DUYET_ACCOUNT_PATH,
    exact: true,
    component: DuyetAccount,
    isPublic: false,
    controller: 'Account',
    action: 'ApproveInternalSoftwareAccess',
    menuAction: 'ApproveInternalSoftwareAccess',
    label: "Duyệt quyền phần mềm",
    menu: true,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TRA_CUU_CAN_BO_PATH,
    exact: true,
    component: TraCuuCanBo,
    isPublic: false,
    controller: 'TraCuuCanBo',
    action: '',
    label: "Tra cứu cán bộ",
    menu: true,
    isPublic: false,
  },
  //role
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    isPublic: false,
    controller: 'Role',
    // controller: '',
    action: '',
    label: "Quyền",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    isPublic: false,
    controller: 'EmailConfig',
    // controller: '',
    action: '',
    label: "Email gửi thông báo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    isPublic: false,
    controller: 'LoginHistory',
    // controller: '',
    action: '',
    label: "Lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    isPublic: false,
    // controller: 'Report',
    controller: '',
    action: '',
    label: "Thống kê lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    isPublic: false,
    controller: 'ApiRoleMapping',
    // controller: '',
    action: '',
    label: "Phân quyền API",
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  // {
  //   path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
  //   exact: true,
  //   component: OpeniddictApplication,
  //   isPublic: false,
  //   controller: 'OpeniddictApplication',
  //   // controller: '',
  //   action: '',
  //   label: "Ứng dụng đăng ký",
  //   menu: true,
  //   isPublic: false,
  // },
  // {
  //   path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
  //   exact: true,
  //   component: OpeniddictApplicationAdd,
  //   isPublic: false,
  //   // controller: 'ApiRoleMapping',
  //   // action:     'Them',
  //   label: "",
  //   menu: false,
  //   isPublic: false,
  // },
  // {
  //   path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
  //   exact: true,
  //   component: OpeniddictApplicationEdit,
  //   isPublic: false,
  //   // controller: 'ApiRoleMapping',
  //   // action:     'Sua',
  //   label: "",
  //   menu: false,
  //   isPublic: false,
  // },
  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    isPublic: false,
    controller: 'Log',
    // controller: '',
    action: '',
    label: "Xem log",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KYSO_PATH,
    exact: true,
    component: KySo,
    isPublic: false,
    controller: 'KySo',
    // controller: '',
    action: '',
    label: "Ký số",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_PATH,
    exact: true,
    component: SignedHuman,
    isPublic: false,
    controller: 'SignedHuman',
    // controller: '',
    action: '',
    label: "Người được ký",
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPaging',
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_CREATE_PATH,
    exact: true,
    component: SignedHumanAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_EDIT_PATH,
    exact: true,
    component: SignedHumanEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_PATH,
    exact: true,
    component: ChuDe,
    isPublic: false,
    controller: 'ChuDe',
    action: '',
    label: "Chủ đề",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_CREATE_PATH,
    exact: true,
    component: ChuDeAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_EDIT_PATH,
    exact: true,
    component: ChuDeEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.HOADONTHANHTOAN_PATH,
    exact: true,
    component: HoaDonThanhToan,
    isPublic: false,
    controller: 'HoaDonThanhToan',
    action: '',
    label: 'Hóa đơn thanh toán',
    menu: true,
    menuAction: 'GetAllByPaging',
  },
  {
    path: URI_INTERNAL.HOADONTHANHTOAN_CREATE_PATH,
    exact: true,
    component: HoaDonThanhToanAdd,
    isPublic: false,
    label: '',
    menu: false,
  },
  {
    path: URI_INTERNAL.HOADONTHANHTOAN_EDIT_PATH,
    exact: true,
    component: HoaDonThanhToanEdit,
    isPublic: false,
    label: '',
    menu: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_PATH,
    exact: true,
    component: DanhMucPhanMem,
    isPublic: false,
    controller: 'DanhMucPhanMem',
    action: '',
    label: 'Danh mục phần mềm',
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPaging',
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_CREATE_PATH,
    exact: true,
    component: DanhMucPhanMemAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_EDIT_PATH,
    exact: true,
    component: DanhMucPhanMemEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_PATH,
    exact: true,
    component: ChuongTrinhHoc,
    isPublic: false,
    controller: 'ChuongTrinhHoc',
    action: '',
    label: 'Chương trình học',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_CREATE_PATH,
    exact: true,
    component: ChuongTrinhHocAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_EDIT_PATH,
    exact: true,
    component: ChuongTrinhHocEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGANH_PATH,
    exact: true,
    component: Nganh,
    isPublic: false,
    controller: 'Nganh',
    action: '',
    label: 'Ngành',
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.NGANH_CREATE_PATH,
    exact: true,
    component: NganhAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NGANH_EDIT_PATH,
    exact: true,
    component: NganhEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_PATH,
    exact: true,
    component: ChuyenNganh,
    isPublic: false,
    controller: 'ChuyenNganh',
    action: '',
    label: 'Chuyên ngành',
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_CREATE_PATH,
    exact: true,
    component: ChuyenNganhAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_EDIT_PATH,
    exact: true,
    component: ChuyenNganhEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH,
    exact: true,
    component: DanhMucVanBangChungChi,
    isPublic: false,
    controller: 'DanhMucVanBangChungChi',
    action: '',
    label: 'Văn bằng chứng chỉ',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_CREATE_PATH,
    exact: true,
    component: DanhMucVanBangChungChiAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_EDIT_PATH,
    exact: true,
    component: DanhMucVanBangChungChiEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_PATH,
    exact: true,
    component: PhamViHanhNghe,
    isPublic: false,
    controller: 'PhamViHanhNghe',
    action: '',
    label: 'Phạm vi hành nghề',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_CREATE_PATH,
    exact: true,
    component: PhamViHanhNgheAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_EDIT_PATH,
    exact: true,
    component: PhamViHanhNgheEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_PATH,
    exact: true,
    component: GiayPhepHanhNghe,
    isPublic: false,
    controller: 'GiayPhepHanhNghe',
    action: '',
    label: 'Giấy phép hành nghề',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHSACHDUYETHOSO_PATH,
    exact: true,
    component: DanhSachDuyetHoSo,
    isPublic: false,
    controller: 'DanhSachDuyetHoSo',
    action: '',
    label: 'Danh sách duyệt hồ sơ',
    menu: true,
    isPublic: false,
    menuAction: 'GetAllByPagingGiayPhepHanhNghe',
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_CREATE_PATH,
    exact: true,
    component: GiayPhepHanhNgheAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_EDIT_PATH,
    exact: true,
    component: GiayPhepHanhNgheEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.VANBANG_PATH,
    exact: true,
    component: VanBang,
    isPublic: false,
    controller: 'VanBang',
    action: '',
    label: 'Văn bằng',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.VANBANG_CREATE_PATH,
    exact: true,
    component: VanBangAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.VANBANG_EDIT_PATH,
    exact: true,
    component: VanBangEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUNGCHINGOAINGU_PATH,
    exact: true,
    component: ChungChiNgoaiNgu,
    isPublic: false,
    controller: 'ChungChiNgoaiNgu',
    action: '',
    label: 'Chứng chỉ ngoại ngữ',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUNGCHINGOAINGU_CREATE_PATH,
    exact: true,
    component: ChungChiNgoaiNguAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUNGCHINGOAINGU_EDIT_PATH,
    exact: true,
    component: ChungChiNgoaiNguEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.THONGKEDUYET_PATH,
    exact: true,
    component: DanhSachDuyetNgoaiNgu,
    isPublic: false,
    controller: 'DanhSachDuyetNgoaiNgu',
    action: '',
    label: "DS Duyệt ngoại ngữ",
    menu: true,
  },
  {
    path: URI_INTERNAL.NHOMTIEUCHI_PATH,
    exact: true,
    component: NhomTieuChi,
    isPublic: false,
    controller: 'NhomTieuChi',
    action: '',
    label: 'Nhóm tiêu chí',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NHOMTIEUCHI_CREATE_PATH,
    exact: true,
    component: NhomTieuChiAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.NHOMTIEUCHI_EDIT_PATH,
    exact: true,
    component: NhomTieuChiEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TIEUCHI_PATH,
    exact: true,
    component: TieuChi,
    isPublic: false,
    controller: 'TieuChi',
    action: '',
    label: 'Tiêu chí',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TIEUCHI_CREATE_PATH,
    exact: true,
    component: TieuChiAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.TIEUCHI_EDIT_PATH,
    exact: true,
    component: TieuChiEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.MUCDANHGIA_PATH,
    exact: true,
    component: MucDanhGia,
    isPublic: false,
    controller: 'MucDanhGia',
    action: '',
    label: 'Mục đánh giá',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.MUCDANHGIA_CREATE_PATH,
    exact: true,
    component: MucDanhGiaAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.MUCDANHGIA_EDIT_PATH,
    exact: true,
    component: MucDanhGiaEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },/*  *//*  *//*  *//*  *//*  *//*  */
  {
    path: URI_INTERNAL.DOTTUYENSINH_PATH,
    exact: true,
    component: DotTuyenSinh,
    isPublic: false,
    controller: 'DotTuyenSinh',
    action: '',
    label: 'Đợt tuyển sinh',
    menu: true,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.DOTTUYENSINH_CREATE_PATH,
    exact: true,
    component: DotTuyenSinhAdd,
    isPublic: false,
    label: "",
    menu: false,
  },
  {
    path: URI_INTERNAL.DOTTUYENSINH_EDIT_PATH,
    exact: true,
    component: DotTuyenSinhEdit,
    isPublic: false,
    label: "",
    menu: false,
  },
  {
    path: URI_INTERNAL.LOPDAOTAOLIENTUC_PATH,
    exact: true,
    component: LopDaoTaoLienTuc,
    isPublic: false,
    controller: 'LopDaoTaoLienTuc',
    action: '',
    label: 'Lớp ĐTLT',
    menu: false,
    isPublic: false,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.LOPDAOTAOLIENTUC_CREATE_PATH,
    exact: true,
    component: LopDaoTaoLienTucAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LOPDAOTAOLIENTUC_EDIT_PATH,
    exact: true,
    component: LopDaoTaoLienTucEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH,
    exact: true,
    component: LopDaoTaoThucHanh,
    isPublic: false,
    controller: 'LopDaoTaoThucHanh',
    action: '',
    label: 'Lớp ĐTTH',
    menu: false,
    isPublic: false,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.LOPDAOTAOTHUCHANH_CREATE_PATH,
    exact: true,
    component: LopDaoTaoThucHanhAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.LOPDAOTAOTHUCHANH_EDIT_PATH,
    exact: true,
    component: LopDaoTaoThucHanhEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANGKY_DOTTUYENSINH_PATH,
    exact: true,
    component: DangKyDotTuyenSinh,
    isPublic: false,
    controller: 'DangKyDotTuyenSinh',
    action: '',
    label: 'Đăng ký tuyển sinh',
    menu: true,
  },
  {
    path: URI_INTERNAL.HOSOTUYENSINH_PATH,
    exact: true,
    component: HoSoTuyenSinh,
    isPublic: false,
    controller: 'HoSoTuyenSinh',
    action: '',
    label: 'Hồ sơ tuyển sinh',
    menu: true,
  },
  {
    path: URI_INTERNAL.DUYET_HOSOTUYENSINH_PATH,
    exact: true,
    component: DuyetHoSoTuyenSinh,
    isPublic: false,
    controller: 'DuyetHoSoTuyenSinh',
    action: '',
    label: 'Duyệt hồ sơ tuyển sinh',
    menu: true,
  },
    {
    path: URI_INTERNAL.BIEUMAUTUYENSINH_PATH,
    exact: true,
    component: BieuMauTuyenSinh,
    isPublic: false,
    controller: 'BieuMauTuyenSinh',
    action: '',
    label: 'Biểu mẫu tuyển sinh',
    menu: true,
    menuAction: 'GetAllByPaging'
  },
  // CME - Cap Nhat Kien Thuc Y Khoa
  {
    path: URI_INTERNAL.CMECONFIG_PATH,
    exact: true,
    component: CMEConfig,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Cấu hình CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEEVENT_PATH,
    exact: true,
    component: CMEEvent,
    isPublic: false,
    controller: 'CMEKhoaDaoTao',
    action: '',
    label: 'Khóa đào tạo CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDICTIONARY_PATH,
    exact: true,
    component: CMEDictionary,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Danh mục CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDUYETHOSO_PATH,
    exact: true,
    component: CMEDuyetHoSo,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Phê duyệt CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDASHBOARD_PATH,
    exact: true,
    component: CMEDashboard,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: 'Dashboard CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMECA_NHAN_PATH,
    exact: true,
    component: CMEHoSo,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: 'Lịch sử CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMECA_NHAN_CREATE_PATH,
    exact: true,
    component: CMEHoSoAdd,
    isPublic: false,
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: `${URI_INTERNAL.CMECA_NHAN_EDIT_PATH}/:id`,
    exact: true,
    component: CMEHoSoEdit,
    isPublic: false,
    label: '',
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDIEUDUONG_EVENT_PATH,
    exact: true,
    component: CMEDieuDuongEvent,
    isPublic: false,
    controller: 'CMEDieuDuongAdmin',
    action: '',
    label: 'Khóa ĐT Điều dưỡng',
    menu: true,
  },

  {
    path: URI_INTERNAL.CMEDIEUDUONG_DUYET_PATH,
    exact: true,
    component: CMEDieuDuongDuyet,
    isPublic: false,
    controller: 'CMEDieuDuongDuyet',
    action: '',
    label: 'Thẩm định CME ĐD',
    menu: true,
  },
  {
    path: URI_INTERNAL.HOSO_NGHIENCUUSINH_PATH,
    exact: true,
    component: HoSoNghienCuuSinh,
    isPublic: false,
    controller: 'HoSoNghienCuuSinh',
    action: '',
    label: 'Hồ sơ Nghiên cứu sinh',
    menu: true,
  },
  {
    path: URI_INTERNAL.GIAIDOAN_DAOTAO_NCS_PATH,
    exact: true,
    component: GiaiDoanDaoTaoNCS,
    isPublic: false,
    label: "Giai đoạn đào tạo",
    menu: false,
  },
  {
    path: URI_INTERNAL.YEUCAU_THAYDOI_NCS_PATH,
    exact: true,
    component: YeuCauThayDoi,
    isPublic: false,
    label: "Yêu cầu thay đổi",
    menu: false,
  },
  {
    path: URI_INTERNAL.QUANLY_HOSO_NCS_PATH,
    exact: true,
    component: QuanLyHoSoNCS,
    isPublic: false,
    controller: 'QuanLyHoSoNghienCuuSinh',
    action: '',
    label: 'Quản lý hồ sơ NCS',
    menu: true,
  },
  {
    path: URI_INTERNAL.QUANLY_GIAIDOAN_DAOTAO_NCS_PATH,
    exact: true,
    component: QuanLyGiaiDoanDaoTaoNCS,
    isPublic: false,
    label: "Giai đoạn đào tạo (Duyệt)",
    menu: false,
  },
  {
    path: URI_INTERNAL.BIEUMAUTIENSI_PATH,
    exact: true,
    component: BieuMauTienSi,
    isPublic: false,
    controller: 'BieuMauTienSi',
    action: '',
    label: 'Biểu mẫu Tiến sĩ',
    menu: true,
    menuAction: 'GetAllByPaging'
  },
  {
    path: URI_INTERNAL.LUUTRUHOSOTIENSI_PATH,
    exact: true,
    component: DanhMucHoSoTienSi,
    isPublic: false,
    controller: 'DanhMucHoSoTienSi',
    action: '',
    label: 'Lưu trữ hồ sơ',
    menu: true,
    menuAction: 'GetAllByPaging'
  },

  {
    path: URI_INTERNAL.DAOTAOTHUCHANH_PATH,
    exact: true,
    component: DaoTaoThucHanh,
    isPublic: false,
    controller: 'TruongThucTap',
    action: '',
    label: 'Cơ sở đào tạo',
    menu: true,
  },
  {
    path: URI_INTERNAL.NGANHDAOTAO_PATH,
    exact: true,
    component: NganhDaoTao,
    isPublic: false,
    controller: 'NganhDaoTao',
    action: '',
    label: 'Ngành đào tạo',
    menu: true,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHDAOTAO_PATH,
    exact: true,
    component: ChuongTrinhDaoTao,
    isPublic: false,
    controller: 'ChuongTrinhDaoTao',
    action: '',
    label: 'Chương trình đào tạo',
    menu: true,
  },
  {
    path: URI_INTERNAL.HOPDONGDAOTAO_PATH,
    exact: true,
    component: HopDongDaoTao,
    isPublic: false,
    controller: 'HopDongNguyenTac',
    action: '',
    label: 'Hợp đồng đào tạo',
    menu: true,
  },
  {
    path: URI_INTERNAL.KHOADAOTAO_PATH,
    exact: true,
    component: KhoaDaoTao,
    isPublic: false,
    controller: 'HopDongChiTiet',
    action: '',
    label: 'Khóa đào tạo',
    menu: true,
  },
  {
    path: URI_INTERNAL.KHOADAOTAO_DETAIL_PATH,
    exact: true,
    component: KhoaDaoTaoDetail,
    isPublic: false,
    controller: 'HopDongChiTiet',
    action: '',
    label: 'Chi tiết khóa học',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhai,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhai',
    action: '',
    label: 'Lớp Đào tạo liên tục (Quản trị)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_GV_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhaiGV,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhaiGV',
    action: '',
    label: 'Lớp Đào tạo liên tục (Giảng viên)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_GV_DETAIL_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhaiDetailGV,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhaiGV',
    action: '',
    label: 'Chi tiết lớp đào tạo liên tục (GV)',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_HV_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhaiHV,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhaiHV',
    action: '',
    label: 'Lớp Đào tạo liên tục (Học viên)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_HV_DETAIL_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhaiDetailHV,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhaiHV',
    action: '',
    label: 'Chi tiết lớp đào tạo liên tục (HV)',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_DAOTAOLIENTUC_DETAIL_PATH,
    exact: true,
    component: LopDaoTaoLienTucTrienKhaiDetail,
    isPublic: false,
    controller: 'LopDaoTaoLienTucTrienKhai',
    action: '',
    label: 'Chi tiết lớp đào tạo liên tục',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhai,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhai',
    action: '',
    label: 'Hướng dẫn thực hành (Quản trị)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_GV_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhaiGV,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhaiGV',
    action: '',
    label: 'Hướng dẫn thực hành (Giảng viên)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_GV_DETAIL_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhaiDetailGV,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhaiGV',
    action: '',
    label: 'Chi tiết hướng dẫn thực hành (GV)',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_HV_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhaiHV,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhaiHV',
    action: '',
    label: 'Hướng dẫn thực hành (Học viên)',
    menu: true,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_HV_DETAIL_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhaiDetailHV,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhaiHV',
    action: '',
    label: 'Chi tiết hướng dẫn thực hành (HV)',
    menu: false,
  },
  {
    path: URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_DETAIL_PATH,
    exact: true,
    component: LopHuongDanThucHanhTrienKhaiDetail,
    isPublic: false,
    controller: 'LopHuongDanThucHanhTrienKhai',
    action: '',
    label: 'Chi tiết hướng dẫn thực hành',
    menu: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    // controller: r.controller,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Danh mục chung",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && (
        r.path === URI_INTERNAL.DUYET_ACCOUNT_PATH ||
        [
          "ChuDe",
          "DanhMucPhanMem",
          "ChuongTrinhHoc",
          "Nganh",
          "ChuyenNganh",
          "HoaDonThanhToan",
          "TraCuuCanBo"
        ].includes(r.controller)
      )
    )
  },
  {
    title: "Quản lý Giấy phép",
    icon: "fas fa-id-card",
    children: appRoutes.filter(r =>
      r.menu && [
        "DanhMucVanBangChungChi",
        "PhamViHanhNghe",
        "GiayPhepHanhNghe",
        "DanhSachDuyetHoSo",
      ].includes(r.controller)
    )
  },
  {
    title: "Quản lý ngoại ngữ",
    icon: "fas fa-language",
    children: appRoutes.filter(r =>
      r.menu && [
        "VanBang",
        "ChungChiNgoaiNgu",
        "DanhSachDuyetNgoaiNgu",
      ].includes(r.controller)
    )
  },
  {
    title: "Tích lũy CME",
    icon: "fas fa-graduation-cap",
    children: appRoutes.filter(r =>
      r.menu && [
        "CMEAdmin",
        "CMEUser",
        "CMEKhoaDaoTao",
        "CMEDieuDuongAdmin",
        "CMEDieuDuongDuyet"
      ].includes(r.controller)
    )
  },
  {
    title: "Đào tạo thực hành",
    icon: "fas fa-stethoscope",
    children: appRoutes.filter(r =>
      r.menu && [
        "TruongThucTap",
        "NganhDaoTao",
        "ChuongTrinhDaoTao",
        "HopDongChiTiet",
        "HopDongNguyenTac",
        "LichHocThucHanh",
      ].includes(r.controller)
    )
  },
  {
    title: "Đào tạo liên tục",
    icon: "fas fa-chalkboard-teacher",
    children: appRoutes.filter(r =>
      r.menu && [
        "LopDaoTaoLienTucTrienKhai",
        "LopDaoTaoLienTucTrienKhaiGV",
        "LopDaoTaoLienTucTrienKhaiHV",
      ].includes(r.controller)
    )
  },
  {
    title: "Hướng dẫn thực hành",
    icon: "fas fa-user-md",
    children: appRoutes.filter(r =>
      r.menu && [
        "LopHuongDanThucHanhTrienKhai",
        "LopHuongDanThucHanhTrienKhaiGV",
        "LopHuongDanThucHanhTrienKhaiHV",
      ].includes(r.controller)
    )
  },
  {
    title: "Quản lý tuyển sinh",
    icon: "fas fa-user-graduate",
    children: appRoutes.filter(r =>
      r.menu && [
        "NhomTieuChi",
        "TieuChi",
        "MucDanhGia",
        "DotTuyenSinh",
        "DangKyDotTuyenSinh",
        "HoSoTuyenSinh",
        "DuyetHoSoTuyenSinh",
        "BieuMauTuyenSinh",
      ].includes(r.controller)
    )
  },
  {
    title: "Đào tạo Tiến sĩ",
    icon: "fas fa-book-reader",
    children: appRoutes.filter(r =>
      r.menu && [
        "HoSoNghienCuuSinh",
        "QuanLyHoSoNghienCuuSinh",
        "BieuMauTienSi",
        "DanhMucHoSoTienSi"
      ].includes(r.controller)
    )
  },
  {
    title: "Chức năng",
    icon: "fas fa-cog",
    requireRoles: ['admin'],
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "SignedHuman",
        "KySo",
      ].includes(r.controller)
    )
  },
  {
    title: "Hệ thống",
    icon: "fas fa-cog",
    requireRoles: ['admin'],
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && r.path !== URI_INTERNAL.DUYET_ACCOUNT_PATH && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "SignedHuman",
        "KySo",
        "Log",
      ].includes(r.controller)
    )
  },
  {
    title: "Báo cáo",
    icon: "fas fa-table",
    // Lấy tất cả route menu thuộc nhóm Báo cáo
    children: appRoutes.filter(r =>
      r.menu && [
        "LoginHistory",
        "StatisticLoginHistory"
      ].includes(r.controller)
    )
  },
];
